import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { SystemService } from 'src/app/service/system.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-medical-check',
  templateUrl: './medical-check.component.html',
  styleUrls: ['./medical-check.component.scss']
})
export class MedicalCheckComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  url: string = "";
  imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  uploadImage: any;
  countries: any;
  regions: any;
  provinces: any;
  city: any;
  maritalStatus: any;
  milStatus: any;
  chronicDiseases1: any;
  chronicDiseases2: any;
  chronicDiseases3: any;
  chronicDiseases4: any;
  appStatusMedicalCheck: any = 50;
  candId: any;
  candNameEn: any;
  candNameAr: any;
  candNatId: any;
  candCode: any;
  photoPath: any = "assets/images/stud-image.png";
  currentDate = new Date();
  CandChronicDiseases: any;
  CandChronicDiseaseId1: any = 0;
  CandChronicDiseaseId2: any = 0;
  CandChronicDiseaseId3: any = 0;
  CandChronicDiseaseId4: any = 0;
  candStatus:any;

  candChronicDisSample = [
    {
      "candidateid": 120,
      "diseasesid": 0,
      // "diseasesid": 20,
      "id": 158,
      "diseaseRemark": "test1t1"
    },
    {
      "candidateid": 120,
      "diseasesid": 10,
      "id": 156,
      "diseaseRemark": "test2t1"
    },
    {
      "candidateid": 120,
      "diseasesid": 70,
      "id": 157,
      "diseaseRemark": "test3t2"
    },
    {
      "candidateid": 120,
      "diseasesid": 80,
      "id": 155,
      "diseaseRemark": "test4t3"
    }
  ];

  medicalCheckData = new FormGroup({
    medicalDate: new FormControl(new Date().toLocaleDateString(), [
      Validators.required,
    ]),
    medicalCheckStatus: new FormControl('', [
      Validators.required,
    ]),
    medicalInterviewComment: new FormControl('', [
      Validators.required,
    ]),
  });
  medicalCheckDataPopUp = new FormGroup({
    candCode: new FormControl(''),
    medicalName1: new FormControl('', [
      Validators.required,
    ]),
    comment1: new FormControl('', [
      Validators.required,
    ]),
    medicalName2: new FormControl('', [
      Validators.required,
    ]),
    comment2: new FormControl('', [
      Validators.required,
    ]),
    medicalName3: new FormControl('', [
      Validators.required,
    ]),
    comment3: new FormControl('', [
      Validators.required,
    ]),
    medicalName4: new FormControl('', [
      Validators.required,
    ]),
    comment4: new FormControl('', [
      Validators.required,
    ]),
  });
  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    private systemService: SystemService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    // console.log(this.globals.userOptions);
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.candId = params['candId'] || "";

        if (this.candId != "") {
          this.getAllChronicDiseases();
          this.getCandById(this.candId);
        } else {

          this.toastr.warning(this.translate.instant('NOT_FOUND'));
          this.router.navigate(['/admission/candidate-inquiry']);
        }
      });
  }
  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        this.medicalCheckDataPopUp.controls.candCode.setValue(data.candCode);
        this.candNameEn = data.fullNameEn;
        this.candNameAr = data.fullNameAr;
        this.candNatId = data.nidNo;
        this.candCode = data.candCode;
        this.candStatus= data.appstatusid;
        this.photoPath = `${environment.API_URL_UTIL}/api/downloadFile/${data.photoFilename}`;

        ///////////////
        this.medicalCheckData.controls.medicalCheckStatus.setValue(data.medicalStatus); // medicalStatus
        this.medicalCheckData.controls.medicalInterviewComment.setValue(data.medicalComment); // medicalComment
        if (data.medicalDate !== undefined && data.medicalDate.length > 0) {
          let medicalDateValue = new Date(data.medicalDate)
          this.medicalCheckData.controls.medicalDate.setValue(medicalDateValue.toLocaleDateString());//medicalDate
        }
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  chronicDiseases() {
    $('#close-ChronicDiseases').click();
  }

  getAllChronicDiseases() {
    // this.showLoader = true;
    this.admService.getChronicDiseases().subscribe(
      data => {
        console.log(data);
        this.chronicDiseases1 = data;
        this.chronicDiseases2 = data;
        this.chronicDiseases3 = data;
        this.chronicDiseases4 = data;

        ///////////
        this.getCandChronicDiseases();

      },
      error => {
        //  this.toastrService.error("can't get candidate inquiries");
        //  this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        // this.updateTable();
      }
    );
  }
  saveAllChronicDiseases() {
    // console.log(this.medicalCheckDataPopUp.controls.medicalName1.value.length > 0);
    if (this.medicalCheckDataPopUp.controls.medicalName1.value != null) {
      if (this.CandChronicDiseaseId1 > 0) {
        this.updateChronicDiseases(this.CandChronicDiseaseId1, this.candId, this.medicalCheckDataPopUp.controls.medicalName1.value
          , this.medicalCheckDataPopUp.controls.comment1.value);
      } else {
        this.saveChronicDiseases(this.candId, this.medicalCheckDataPopUp.controls.medicalName1.value
          , this.medicalCheckDataPopUp.controls.comment1.value);
      }
    }
    if (this.medicalCheckDataPopUp.controls.medicalName2.value != null) {
      if (this.CandChronicDiseaseId2 > 0) {
        this.updateChronicDiseases(this.CandChronicDiseaseId2, this.candId, this.medicalCheckDataPopUp.controls.medicalName2.value
          , this.medicalCheckDataPopUp.controls.comment2.value);
      } else {
        this.saveChronicDiseases(this.candId, this.medicalCheckDataPopUp.controls.medicalName2.value
          , this.medicalCheckDataPopUp.controls.comment2.value);
      }
    }
    if (this.medicalCheckDataPopUp.controls.medicalName3.value != null) {
      if (this.CandChronicDiseaseId3 > 0) {
        this.updateChronicDiseases(this.CandChronicDiseaseId3, this.candId, this.medicalCheckDataPopUp.controls.medicalName3.value
          , this.medicalCheckDataPopUp.controls.comment3.value);
      } else {
        this.saveChronicDiseases(this.candId, this.medicalCheckDataPopUp.controls.medicalName3.value
          , this.medicalCheckDataPopUp.controls.comment3.value);
      }
    }
    if (this.medicalCheckDataPopUp.controls.medicalName4.value != null) {
      if (this.CandChronicDiseaseId4 > 0) {
        this.updateChronicDiseases(this.CandChronicDiseaseId4, this.candId, this.medicalCheckDataPopUp.controls.medicalName4.value
          , this.medicalCheckDataPopUp.controls.comment4.value);
      } else {
        this.saveChronicDiseases(this.candId, this.medicalCheckDataPopUp.controls.medicalName4.value
          , this.medicalCheckDataPopUp.controls.comment4.value);
      }
    }
  }

  // updateAllChronicDiseases() {
  //   // console.log(this.medicalCheckDataPopUp.controls.medicalName1.value.length > 0);
  //   let sampleId = 0;
  //   if (this.medicalCheckDataPopUp.controls.medicalName1.value != null) {
  //     this.updateChronicDiseases(sampleId, this.candId, this.medicalCheckDataPopUp.controls.medicalName1.value
  //       , this.medicalCheckDataPopUp.controls.comment1.value)
  //   }
  //   if (this.medicalCheckDataPopUp.controls.medicalName2.value != null) {
  //     this.updateChronicDiseases(sampleId, this.candId, this.medicalCheckDataPopUp.controls.medicalName2.value
  //       , this.medicalCheckDataPopUp.controls.comment2.value)
  //   }
  //   if (this.medicalCheckDataPopUp.controls.medicalName3.value != null) {
  //     this.updateChronicDiseases(sampleId, this.candId, this.medicalCheckDataPopUp.controls.medicalName3.value
  //       , this.medicalCheckDataPopUp.controls.comment3.value)
  //   }
  //   if (this.medicalCheckDataPopUp.controls.medicalName4.value != null) {
  //     this.updateChronicDiseases(sampleId, this.candId, this.medicalCheckDataPopUp.controls.medicalName4.value
  //       , this.medicalCheckDataPopUp.controls.comment4.value)
  //   }
  // }


  saveChronicDiseases(canId: any, desId: any, remark: string) {
    this.admService.addChronicDiseases(canId, desId, remark
    )
      .subscribe(
        data => {
          this.toastr.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
          this.creating = false
        },
        error => {
          this.creating = false
          this.toastr.warning(this.translate.instant("CAN_NOT_UPDATE"));
        },
        () => this.creating = false
      );
  }

  updateChronicDiseases(chDisId: any, canId: any, desId: any, remark: string) {
    this.admService.updateChronicDiseases(chDisId, canId, desId, remark
    )
      .subscribe(
        data => {
          this.toastr.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
          this.creating = false
        },
        error => {
          this.creating = false
          this.toastr.warning(this.translate.instant("CAN_NOT_UPDATE"));
        },
        () => this.creating = false
      );
  }

  medicalCheckSubmit() {
    this.creating = true;
    console.log("befor valid");
    if (this.medicalCheckData.valid) {
      console.log("in valid");
      this.creating = true;
      // this.admService.addMedicalChekData(this.candId,
      //   this.medicalCheckData.controls.medicalCheckStatus.value,
      //   this.medicalCheckData.controls.medicalInterviewComment.value,
      //   this.currentDate,
      //   this.appStatusMedicalCheck
      // )
      let candStatusUpdate=this.appStatusMedicalCheck;
      if(this.candStatus>=55){
        candStatusUpdate=this.candStatus;
      }
      this.admService.addMedicalChekDataAndUsername(this.candId,
        this.medicalCheckData.controls.medicalCheckStatus.value,
        this.medicalCheckData.controls.medicalInterviewComment.value,
        this.currentDate,
        candStatusUpdate,
        this.globals.currentUserInfo.username
      )
        .subscribe(
          data => {
            this.saveAllChronicDiseases();
            this.router.navigate(['/admission/candidate-inquiry']);
            this.toastr.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
          },
          error => {
            this.creating = false
            this.toastr.warning(this.translate.instant("CAN_NOT_UPDATE"));
          },
          () => this.creating = false
        );
    }
    else {
      console.log("non valid");
      this.medicalCheckData.markAllAsTouched();
      this.medicalCheckData.markAsDirty();
      this.creating = false;
    }
  }

  medicalCheckChange() {

  }

  getCandChronicDiseases() {

    this.admService.getCandChronicDiseases(this.candId).subscribe(
      data => {
        // this.CandChronicDiseases = this.candChronicDisSample;
        this.CandChronicDiseases = data;
        // this.CandChronicDiseases = [];
        if (this.CandChronicDiseases[0] !== undefined) {
          if (this.CandChronicDiseases[0].diseasesid > 0) {
            this.medicalCheckDataPopUp.controls.medicalName1.setValue(this.CandChronicDiseases[0].diseasesid);
          } else {
            this.medicalCheckDataPopUp.controls.medicalName1.setValue("");
          }
          this.medicalCheckDataPopUp.controls.comment1.setValue(this.CandChronicDiseases[0].diseaseRemark);
          this.CandChronicDiseaseId1 = this.CandChronicDiseases[0].id;
        }

        if (this.CandChronicDiseases[1] !== undefined) {
          if (this.CandChronicDiseases[1].diseasesid > 0) {
            this.medicalCheckDataPopUp.controls.medicalName2.setValue(this.CandChronicDiseases[1].diseasesid);
          } else {
            this.medicalCheckDataPopUp.controls.medicalName2.setValue("");
          }
          this.medicalCheckDataPopUp.controls.comment2.setValue(this.CandChronicDiseases[1].diseaseRemark);
          this.CandChronicDiseaseId2 = this.CandChronicDiseases[1].id;
        }

        if (this.CandChronicDiseases[2] !== undefined) {
          if (this.CandChronicDiseases[2].diseasesid > 0) {
            this.medicalCheckDataPopUp.controls.medicalName3.setValue(this.CandChronicDiseases[2].diseasesid);
          } else {
            this.medicalCheckDataPopUp.controls.medicalName3.setValue("");
          }
          this.medicalCheckDataPopUp.controls.comment3.setValue(this.CandChronicDiseases[2].diseaseRemark);
          this.CandChronicDiseaseId3 = this.CandChronicDiseases[2].id;
        }

        if (this.CandChronicDiseases[3] !== undefined) {
          if (this.CandChronicDiseases[3].diseasesid > 0) {
            this.medicalCheckDataPopUp.controls.medicalName4.setValue(this.CandChronicDiseases[3].diseasesid);
          } else {
            this.medicalCheckDataPopUp.controls.medicalName4.setValue("");
          }
          this.medicalCheckDataPopUp.controls.comment4.setValue(this.CandChronicDiseases[3].diseaseRemark);
          this.CandChronicDiseaseId4 = this.CandChronicDiseases[3].id;
        }
      },
      error => {
        this.toastr.warning(this.translate.instant("CAN_NOT_GET_CAND_DISEASES"));
      }
    );
  }


}
